import { getUserById } from '../../../helpers/getUserById';

export const getSeenMessage = (seen, users, currenUserId) =>
	'seen by ' +
	seen
		.filter((userId) => userId !== currenUserId)
		.map((userId) => getUserById(userId, users).username)
		.join(', ');
